import React from 'react';
import Button from "./Button";
import {
    useNavigate,
} from 'react-router-dom';


const MESSAGES = {
    soon: "Тун удахгүй",
    unauthorized: "Хандах эрхгүй",
};

const Error = ({ type }) => {
    const navigate = useNavigate();
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center text-[#0987F3] text-7xl font-semibold uppercase space-y-14">
            <p>{MESSAGES[type] ?? "Хуудас олдсонгүй"}
                <span className='text-cyan-400'>.</span></p>
            <Button style='bg-[#0168D7] text-white text-sm font-semibold rounded-md w-[200px] h-10 shadow-lg hover:opacity-90 duration-150' name='Буцах' onclick={() => navigate(-1)}/>
        </div>
    );
}

export default Error;